import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-fontawesome-icon-modal-select',
  templateUrl: './fontawesome-icon-modal-select.component.html',
  styleUrl: './fontawesome-icon-modal-select.component.scss',
  standalone: false
})
export class FontawesomeIconModalSelectComponent {
  @Input() height: number;
  constructor(public activeModal: NgbActiveModal) {}

  selectIcon(icon){
    this.activeModal.close(icon);
  }
}
